import { useEffect, useMemo, useState } from 'react';
import { formatDonorFeedLine } from '@/lib/recent-donor-feed';
import { useRecentDonorFeed } from '@/lib/use-recent-donor-feed';

export function LiveDonorTicker(): JSX.Element | null {
  const { entries, loading } = useRecentDonorFeed(10, 'LiveDonorTicker');
  const [activeIndex, setActiveIndex] = useState(0);

  const lines = useMemo(
    () => entries.map((entry) => formatDonorFeedLine(entry)).filter((line) => line.length > 0),
    [entries]
  );

  useEffect(() => {
    if (lines.length <= 1) return undefined;
    const interval = globalThis.setInterval(() => {
      setActiveIndex((previous) => (previous + 1) % lines.length);
    }, 5000);
    return () => globalThis.clearInterval(interval);
  }, [lines.length]);

  if (loading) {
    return (
      <p className="text-sm text-gray-600 italic" aria-live="polite">
        Loading recent gifts…
      </p>
    );
  }

  if (lines.length === 0) {
    return (
      <p className="text-sm text-gray-600 italic">
        Be among the first supporters on the GSGO donor wall today.
      </p>
    );
  }

  const line = lines[activeIndex % lines.length];

  return (
    <p className="text-sm font-medium text-teal-900" aria-live="polite">
      <span className="mr-1" aria-hidden>
        ✨
      </span>
      {line}
    </p>
  );
}
